const getAgentName = agent => {
  if (!agent) {
    return '-';
  }
  const { agent_id, realname, nickname } = agent;
  let agentName = `#${agent_id}`;
  if (agent) {
    agentName = realname || nickname || agentName;
  }
  return agentName;
};

const getAgentInfoById = (agentList, id) => {
  const agent = agentList.find(val => val.id === id);
  return {
    ...agent,
    name: getAgentName(agent)
  };
};

export { getAgentName, getAgentInfoById };
